import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
  Time: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Aeropuerto = {
  __typename?: 'Aeropuerto';
  aeropuerto: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  origen: Scalars['String']['output'];
  tiempoVueloInternacional: Scalars['String']['output'];
  tiempoVueloNacional: Scalars['String']['output'];
  toleranciaDeEspera: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AeropuertoEntity = {
  __typename?: 'AeropuertoEntity';
  attributes?: Maybe<Aeropuerto>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AeropuertoEntityResponse = {
  __typename?: 'AeropuertoEntityResponse';
  data?: Maybe<AeropuertoEntity>;
};

export type AeropuertoEntityResponseCollection = {
  __typename?: 'AeropuertoEntityResponseCollection';
  data: Array<AeropuertoEntity>;
  meta: ResponseCollectionMeta;
};

export type AeropuertoFiltersInput = {
  aeropuerto?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<AeropuertoFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<AeropuertoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AeropuertoFiltersInput>>>;
  origen?: InputMaybe<StringFilterInput>;
  tiempoVueloInternacional?: InputMaybe<StringFilterInput>;
  tiempoVueloNacional?: InputMaybe<StringFilterInput>;
  toleranciaDeEspera?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AeropuertoInput = {
  aeropuerto?: InputMaybe<Scalars['String']['input']>;
  origen?: InputMaybe<Scalars['String']['input']>;
  tiempoVueloInternacional?: InputMaybe<Scalars['String']['input']>;
  tiempoVueloNacional?: InputMaybe<Scalars['String']['input']>;
  toleranciaDeEspera?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoriaTour = {
  __typename?: 'CategoriaTour';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  estado?: Maybe<Scalars['Boolean']['output']>;
  nombre: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tours?: Maybe<TourRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CategoriaTourToursArgs = {
  filters?: InputMaybe<TourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CategoriaTourEntity = {
  __typename?: 'CategoriaTourEntity';
  attributes?: Maybe<CategoriaTour>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CategoriaTourEntityResponse = {
  __typename?: 'CategoriaTourEntityResponse';
  data?: Maybe<CategoriaTourEntity>;
};

export type CategoriaTourEntityResponseCollection = {
  __typename?: 'CategoriaTourEntityResponseCollection';
  data: Array<CategoriaTourEntity>;
  meta: ResponseCollectionMeta;
};

export type CategoriaTourFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CategoriaTourFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  estado?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  nombre?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CategoriaTourFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CategoriaTourFiltersInput>>>;
  slug?: InputMaybe<StringFilterInput>;
  tours?: InputMaybe<TourFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CategoriaTourInput = {
  estado?: InputMaybe<Scalars['Boolean']['input']>;
  nombre?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CategoriaTourRelationResponseCollection = {
  __typename?: 'CategoriaTourRelationResponseCollection';
  data: Array<CategoriaTourEntity>;
};

export type Ciudade = {
  __typename?: 'Ciudade';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  estado?: Maybe<Scalars['Boolean']['output']>;
  imagen?: Maybe<UploadFileEntityResponse>;
  nombre?: Maybe<Scalars['String']['output']>;
  tours?: Maybe<TourRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CiudadeToursArgs = {
  filters?: InputMaybe<TourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CiudadeEntity = {
  __typename?: 'CiudadeEntity';
  attributes?: Maybe<Ciudade>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CiudadeEntityResponse = {
  __typename?: 'CiudadeEntityResponse';
  data?: Maybe<CiudadeEntity>;
};

export type CiudadeEntityResponseCollection = {
  __typename?: 'CiudadeEntityResponseCollection';
  data: Array<CiudadeEntity>;
  meta: ResponseCollectionMeta;
};

export type CiudadeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CiudadeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  estado?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  nombre?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CiudadeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CiudadeFiltersInput>>>;
  tours?: InputMaybe<TourFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CiudadeInput = {
  estado?: InputMaybe<Scalars['Boolean']['input']>;
  imagen?: InputMaybe<Scalars['ID']['input']>;
  nombre?: InputMaybe<Scalars['String']['input']>;
  tours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CiudadeRelationResponseCollection = {
  __typename?: 'CiudadeRelationResponseCollection';
  data: Array<CiudadeEntity>;
};

export type Cms = {
  __typename?: 'Cms';
  DescripcionVideo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  descripcionBoletin?: Maybe<Scalars['String']['output']>;
  descripcionComoFunciona?: Maybe<Scalars['String']['output']>;
  descripcionTestimonios?: Maybe<Scalars['String']['output']>;
  descripcionTours?: Maybe<Scalars['String']['output']>;
  img1Header?: Maybe<UploadFileEntityResponse>;
  img2Header?: Maybe<UploadFileEntityResponse>;
  img3Header?: Maybe<UploadFileEntityResponse>;
  item1Boletin?: Maybe<Scalars['String']['output']>;
  item1DescripcionComoFunciona?: Maybe<Scalars['String']['output']>;
  item1TituloComoFunciona?: Maybe<Scalars['String']['output']>;
  item2Boletin?: Maybe<Scalars['String']['output']>;
  item2DescripcionComoFunciona?: Maybe<Scalars['String']['output']>;
  item2TituloComoFunciona?: Maybe<Scalars['String']['output']>;
  item3DescripcionComoFunciona?: Maybe<Scalars['String']['output']>;
  item3TituloComoFunciona?: Maybe<Scalars['String']['output']>;
  itemDescripcion1Beneficios?: Maybe<Scalars['String']['output']>;
  itemDescripcion2Beneficios?: Maybe<Scalars['String']['output']>;
  itemDescripcion3Beneficios?: Maybe<Scalars['String']['output']>;
  itemTitulo1Beneficios?: Maybe<Scalars['String']['output']>;
  itemTitulo2Beneficios?: Maybe<Scalars['String']['output']>;
  itemTitulo3Beneficios?: Maybe<Scalars['String']['output']>;
  logoClaro?: Maybe<UploadFileEntityResponse>;
  logoOscuro?: Maybe<UploadFileEntityResponse>;
  sloganBeneficios?: Maybe<Scalars['String']['output']>;
  subTituloCiudades?: Maybe<Scalars['String']['output']>;
  subTituloHeader?: Maybe<Scalars['String']['output']>;
  tag1Beneficios?: Maybe<Scalars['String']['output']>;
  tag2Beneficios?: Maybe<Scalars['String']['output']>;
  tag3Beneficios?: Maybe<Scalars['String']['output']>;
  textoBotonHeader?: Maybe<Scalars['String']['output']>;
  tituloBeneficios?: Maybe<Scalars['String']['output']>;
  tituloBoletin?: Maybe<Scalars['String']['output']>;
  tituloCiudades?: Maybe<Scalars['String']['output']>;
  tituloComoFunciona?: Maybe<Scalars['String']['output']>;
  tituloHeader?: Maybe<Scalars['String']['output']>;
  tituloTestimonios?: Maybe<Scalars['String']['output']>;
  tituloTours?: Maybe<Scalars['String']['output']>;
  tituloVideo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videos?: Maybe<UploadFileRelationResponseCollection>;
};


export type CmsVideosArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CmsEntity = {
  __typename?: 'CmsEntity';
  attributes?: Maybe<Cms>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CmsEntityResponse = {
  __typename?: 'CmsEntityResponse';
  data?: Maybe<CmsEntity>;
};

export type CmsInput = {
  DescripcionVideo?: InputMaybe<Scalars['String']['input']>;
  descripcionBoletin?: InputMaybe<Scalars['String']['input']>;
  descripcionComoFunciona?: InputMaybe<Scalars['String']['input']>;
  descripcionTestimonios?: InputMaybe<Scalars['String']['input']>;
  descripcionTours?: InputMaybe<Scalars['String']['input']>;
  img1Header?: InputMaybe<Scalars['ID']['input']>;
  img2Header?: InputMaybe<Scalars['ID']['input']>;
  img3Header?: InputMaybe<Scalars['ID']['input']>;
  item1Boletin?: InputMaybe<Scalars['String']['input']>;
  item1DescripcionComoFunciona?: InputMaybe<Scalars['String']['input']>;
  item1TituloComoFunciona?: InputMaybe<Scalars['String']['input']>;
  item2Boletin?: InputMaybe<Scalars['String']['input']>;
  item2DescripcionComoFunciona?: InputMaybe<Scalars['String']['input']>;
  item2TituloComoFunciona?: InputMaybe<Scalars['String']['input']>;
  item3DescripcionComoFunciona?: InputMaybe<Scalars['String']['input']>;
  item3TituloComoFunciona?: InputMaybe<Scalars['String']['input']>;
  itemDescripcion1Beneficios?: InputMaybe<Scalars['String']['input']>;
  itemDescripcion2Beneficios?: InputMaybe<Scalars['String']['input']>;
  itemDescripcion3Beneficios?: InputMaybe<Scalars['String']['input']>;
  itemTitulo1Beneficios?: InputMaybe<Scalars['String']['input']>;
  itemTitulo2Beneficios?: InputMaybe<Scalars['String']['input']>;
  itemTitulo3Beneficios?: InputMaybe<Scalars['String']['input']>;
  logoClaro?: InputMaybe<Scalars['ID']['input']>;
  logoOscuro?: InputMaybe<Scalars['ID']['input']>;
  sloganBeneficios?: InputMaybe<Scalars['String']['input']>;
  subTituloCiudades?: InputMaybe<Scalars['String']['input']>;
  subTituloHeader?: InputMaybe<Scalars['String']['input']>;
  tag1Beneficios?: InputMaybe<Scalars['String']['input']>;
  tag2Beneficios?: InputMaybe<Scalars['String']['input']>;
  tag3Beneficios?: InputMaybe<Scalars['String']['input']>;
  textoBotonHeader?: InputMaybe<Scalars['String']['input']>;
  tituloBeneficios?: InputMaybe<Scalars['String']['input']>;
  tituloBoletin?: InputMaybe<Scalars['String']['input']>;
  tituloCiudades?: InputMaybe<Scalars['String']['input']>;
  tituloComoFunciona?: InputMaybe<Scalars['String']['input']>;
  tituloHeader?: InputMaybe<Scalars['String']['input']>;
  tituloTestimonios?: InputMaybe<Scalars['String']['input']>;
  tituloTours?: InputMaybe<Scalars['String']['input']>;
  tituloVideo?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type Compra = {
  __typename?: 'Compra';
  cantidadDePersonas?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  estado?: Maybe<Scalars['Boolean']['output']>;
  fechaDeCompra?: Maybe<Scalars['String']['output']>;
  fechadelServicio?: Maybe<Scalars['String']['output']>;
  idCompraMercadoPago?: Maybe<Scalars['String']['output']>;
  idMoneda?: Maybe<Scalars['String']['output']>;
  orderMercadoPago?: Maybe<Scalars['JSON']['output']>;
  payerMercadoPago?: Maybe<Scalars['JSON']['output']>;
  paymentMethodMercadoPago?: Maybe<Scalars['JSON']['output']>;
  total?: Maybe<Scalars['Long']['output']>;
  tour?: Maybe<TourEntityResponse>;
  traslado?: Maybe<TrasladoEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users_permissions_user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type CompraEntity = {
  __typename?: 'CompraEntity';
  attributes?: Maybe<Compra>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CompraEntityResponse = {
  __typename?: 'CompraEntityResponse';
  data?: Maybe<CompraEntity>;
};

export type CompraEntityResponseCollection = {
  __typename?: 'CompraEntityResponseCollection';
  data: Array<CompraEntity>;
  meta: ResponseCollectionMeta;
};

export type CompraFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CompraFiltersInput>>>;
  cantidadDePersonas?: InputMaybe<IntFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  estado?: InputMaybe<BooleanFilterInput>;
  fechaDeCompra?: InputMaybe<StringFilterInput>;
  fechadelServicio?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  idCompraMercadoPago?: InputMaybe<StringFilterInput>;
  idMoneda?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CompraFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CompraFiltersInput>>>;
  orderMercadoPago?: InputMaybe<JsonFilterInput>;
  payerMercadoPago?: InputMaybe<JsonFilterInput>;
  paymentMethodMercadoPago?: InputMaybe<JsonFilterInput>;
  total?: InputMaybe<LongFilterInput>;
  tour?: InputMaybe<TourFiltersInput>;
  traslado?: InputMaybe<TrasladoFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users_permissions_user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type CompraInput = {
  cantidadDePersonas?: InputMaybe<Scalars['Int']['input']>;
  estado?: InputMaybe<Scalars['Boolean']['input']>;
  fechaDeCompra?: InputMaybe<Scalars['String']['input']>;
  fechadelServicio?: InputMaybe<Scalars['String']['input']>;
  idCompraMercadoPago?: InputMaybe<Scalars['String']['input']>;
  idMoneda?: InputMaybe<Scalars['String']['input']>;
  orderMercadoPago?: InputMaybe<Scalars['JSON']['input']>;
  payerMercadoPago?: InputMaybe<Scalars['JSON']['input']>;
  paymentMethodMercadoPago?: InputMaybe<Scalars['JSON']['input']>;
  total?: InputMaybe<Scalars['Long']['input']>;
  tour?: InputMaybe<Scalars['ID']['input']>;
  traslado?: InputMaybe<Scalars['ID']['input']>;
  users_permissions_user?: InputMaybe<Scalars['ID']['input']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DestinoInfo = {
  __typename?: 'DestinoInfo';
  count?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  taxonomy?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<UploadFileEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DestinoInfoEntity = {
  __typename?: 'DestinoInfoEntity';
  attributes?: Maybe<DestinoInfo>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type DestinoInfoEntityResponse = {
  __typename?: 'DestinoInfoEntityResponse';
  data?: Maybe<DestinoInfoEntity>;
};

export type DestinoInfoEntityResponseCollection = {
  __typename?: 'DestinoInfoEntityResponseCollection';
  data: Array<DestinoInfoEntity>;
  meta: ResponseCollectionMeta;
};

export type DestinoInfoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DestinoInfoFiltersInput>>>;
  count?: InputMaybe<LongFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  href?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  listingType?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DestinoInfoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DestinoInfoFiltersInput>>>;
  taxonomy?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DestinoInfoInput = {
  count?: InputMaybe<Scalars['Long']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  listingType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  taxonomy?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph = Aeropuerto | CategoriaTour | Ciudade | Cms | Compra | DestinoInfo | I18NLocale | Pedido | Tour | Traslado | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | Vehiculo | Zona;

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  contains?: InputMaybe<Scalars['Long']['input']>;
  containsi?: InputMaybe<Scalars['Long']['input']>;
  endsWith?: InputMaybe<Scalars['Long']['input']>;
  eq?: InputMaybe<Scalars['Long']['input']>;
  eqi?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ne?: InputMaybe<Scalars['Long']['input']>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars['Long']['input']>;
  notContainsi?: InputMaybe<Scalars['Long']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  startsWith?: InputMaybe<Scalars['Long']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAeropuerto?: Maybe<AeropuertoEntityResponse>;
  createCategoriaTour?: Maybe<CategoriaTourEntityResponse>;
  createCiudade?: Maybe<CiudadeEntityResponse>;
  createCompra?: Maybe<CompraEntityResponse>;
  createDestinoInfo?: Maybe<DestinoInfoEntityResponse>;
  createPedido?: Maybe<PedidoEntityResponse>;
  createTour?: Maybe<TourEntityResponse>;
  createTraslado?: Maybe<TrasladoEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createVehiculo?: Maybe<VehiculoEntityResponse>;
  createZona?: Maybe<ZonaEntityResponse>;
  deleteAeropuerto?: Maybe<AeropuertoEntityResponse>;
  deleteCategoriaTour?: Maybe<CategoriaTourEntityResponse>;
  deleteCiudade?: Maybe<CiudadeEntityResponse>;
  deleteCms?: Maybe<CmsEntityResponse>;
  deleteCompra?: Maybe<CompraEntityResponse>;
  deleteDestinoInfo?: Maybe<DestinoInfoEntityResponse>;
  deletePedido?: Maybe<PedidoEntityResponse>;
  deleteTour?: Maybe<TourEntityResponse>;
  deleteTraslado?: Maybe<TrasladoEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteVehiculo?: Maybe<VehiculoEntityResponse>;
  deleteZona?: Maybe<ZonaEntityResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateAeropuerto?: Maybe<AeropuertoEntityResponse>;
  updateCategoriaTour?: Maybe<CategoriaTourEntityResponse>;
  updateCiudade?: Maybe<CiudadeEntityResponse>;
  updateCms?: Maybe<CmsEntityResponse>;
  updateCompra?: Maybe<CompraEntityResponse>;
  updateDestinoInfo?: Maybe<DestinoInfoEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updatePedido?: Maybe<PedidoEntityResponse>;
  updateTour?: Maybe<TourEntityResponse>;
  updateTraslado?: Maybe<TrasladoEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateVehiculo?: Maybe<VehiculoEntityResponse>;
  updateZona?: Maybe<ZonaEntityResponse>;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateAeropuertoArgs = {
  data: AeropuertoInput;
};


export type MutationCreateCategoriaTourArgs = {
  data: CategoriaTourInput;
};


export type MutationCreateCiudadeArgs = {
  data: CiudadeInput;
};


export type MutationCreateCompraArgs = {
  data: CompraInput;
};


export type MutationCreateDestinoInfoArgs = {
  data: DestinoInfoInput;
};


export type MutationCreatePedidoArgs = {
  data: PedidoInput;
};


export type MutationCreateTourArgs = {
  data: TourInput;
};


export type MutationCreateTrasladoArgs = {
  data: TrasladoInput;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationCreateVehiculoArgs = {
  data: VehiculoInput;
};


export type MutationCreateZonaArgs = {
  data: ZonaInput;
};


export type MutationDeleteAeropuertoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCategoriaTourArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCiudadeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompraArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDestinoInfoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePedidoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTourArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTrasladoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVehiculoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteZonaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateAeropuertoArgs = {
  data: AeropuertoInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCategoriaTourArgs = {
  data: CategoriaTourInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCiudadeArgs = {
  data: CiudadeInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCmsArgs = {
  data: CmsInput;
};


export type MutationUpdateCompraArgs = {
  data: CompraInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDestinoInfoArgs = {
  data: DestinoInfoInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdatePedidoArgs = {
  data: PedidoInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTourArgs = {
  data: TourInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTrasladoArgs = {
  data: TrasladoInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateVehiculoArgs = {
  data: VehiculoInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateZonaArgs = {
  data: ZonaInput;
  id: Scalars['ID']['input'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Pedido = {
  __typename?: 'Pedido';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  estado?: Maybe<Scalars['Boolean']['output']>;
  traslado?: Maybe<TrasladoEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users_permissions_user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type PedidoEntity = {
  __typename?: 'PedidoEntity';
  attributes?: Maybe<Pedido>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PedidoEntityResponse = {
  __typename?: 'PedidoEntityResponse';
  data?: Maybe<PedidoEntity>;
};

export type PedidoEntityResponseCollection = {
  __typename?: 'PedidoEntityResponseCollection';
  data: Array<PedidoEntity>;
  meta: ResponseCollectionMeta;
};

export type PedidoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PedidoFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  estado?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PedidoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PedidoFiltersInput>>>;
  traslado?: InputMaybe<TrasladoFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users_permissions_user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type PedidoInput = {
  estado?: InputMaybe<Scalars['Boolean']['input']>;
  traslado?: InputMaybe<Scalars['ID']['input']>;
  users_permissions_user?: InputMaybe<Scalars['ID']['input']>;
};

export type Query = {
  __typename?: 'Query';
  aeropuerto?: Maybe<AeropuertoEntityResponse>;
  aeropuertos?: Maybe<AeropuertoEntityResponseCollection>;
  categoriaTour?: Maybe<CategoriaTourEntityResponse>;
  categoriaTours?: Maybe<CategoriaTourEntityResponseCollection>;
  ciudade?: Maybe<CiudadeEntityResponse>;
  ciudades?: Maybe<CiudadeEntityResponseCollection>;
  cms?: Maybe<CmsEntityResponse>;
  compra?: Maybe<CompraEntityResponse>;
  compras?: Maybe<CompraEntityResponseCollection>;
  destinoInfo?: Maybe<DestinoInfoEntityResponse>;
  destinoInfos?: Maybe<DestinoInfoEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  pedido?: Maybe<PedidoEntityResponse>;
  pedidos?: Maybe<PedidoEntityResponseCollection>;
  tour?: Maybe<TourEntityResponse>;
  tours?: Maybe<TourEntityResponseCollection>;
  traslado?: Maybe<TrasladoEntityResponse>;
  traslados?: Maybe<TrasladoEntityResponseCollection>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  vehiculo?: Maybe<VehiculoEntityResponse>;
  vehiculos?: Maybe<VehiculoEntityResponseCollection>;
  zona?: Maybe<ZonaEntityResponse>;
  zonas?: Maybe<ZonaEntityResponseCollection>;
};


export type QueryAeropuertoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAeropuertosArgs = {
  filters?: InputMaybe<AeropuertoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCategoriaTourArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCategoriaToursArgs = {
  filters?: InputMaybe<CategoriaTourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCiudadeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCiudadesArgs = {
  filters?: InputMaybe<CiudadeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCompraArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryComprasArgs = {
  filters?: InputMaybe<CompraFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDestinoInfoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDestinoInfosArgs = {
  filters?: InputMaybe<DestinoInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPedidoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPedidosArgs = {
  filters?: InputMaybe<PedidoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTourArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryToursArgs = {
  filters?: InputMaybe<TourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTrasladoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTrasladosArgs = {
  filters?: InputMaybe<TrasladoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryVehiculoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVehiculosArgs = {
  filters?: InputMaybe<VehiculoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryZonaArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryZonasArgs = {
  filters?: InputMaybe<ZonaFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type TimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Time']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Time']['input']>>>;
  contains?: InputMaybe<Scalars['Time']['input']>;
  containsi?: InputMaybe<Scalars['Time']['input']>;
  endsWith?: InputMaybe<Scalars['Time']['input']>;
  eq?: InputMaybe<Scalars['Time']['input']>;
  eqi?: InputMaybe<Scalars['Time']['input']>;
  gt?: InputMaybe<Scalars['Time']['input']>;
  gte?: InputMaybe<Scalars['Time']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Time']['input']>>>;
  lt?: InputMaybe<Scalars['Time']['input']>;
  lte?: InputMaybe<Scalars['Time']['input']>;
  ne?: InputMaybe<Scalars['Time']['input']>;
  not?: InputMaybe<TimeFilterInput>;
  notContains?: InputMaybe<Scalars['Time']['input']>;
  notContainsi?: InputMaybe<Scalars['Time']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Time']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Time']['input']>>>;
  startsWith?: InputMaybe<Scalars['Time']['input']>;
};

export type Tour = {
  __typename?: 'Tour';
  Descripcion: Scalars['String']['output'];
  DescripcionCorta?: Maybe<Scalars['String']['output']>;
  Galeria?: Maybe<UploadFileRelationResponseCollection>;
  ImagenDestacada: UploadFileEntityResponse;
  Nombre: Scalars['String']['output'];
  VisibilidadClienteFinal?: Maybe<Scalars['Boolean']['output']>;
  antesdeAsistir?: Maybe<Scalars['String']['output']>;
  cantidadStock?: Maybe<Scalars['Long']['output']>;
  categoria_tours?: Maybe<CategoriaTourRelationResponseCollection>;
  ciudad?: Maybe<Scalars['String']['output']>;
  ciudades?: Maybe<CiudadeRelationResponseCollection>;
  contieneStock?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  descuento?: Maybe<Scalars['Int']['output']>;
  etiquetas?: Maybe<Scalars['String']['output']>;
  informacionGeneral?: Maybe<Scalars['JSON']['output']>;
  medidasHigiene?: Maybe<Scalars['JSON']['output']>;
  nombreFacturarAgencia?: Maybe<Scalars['String']['output']>;
  politicasdeCancelacion?: Maybe<Scalars['String']['output']>;
  precio: Scalars['Long']['output'];
  proveedor?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variantes?: Maybe<Scalars['JSON']['output']>;
};


export type TourGaleriaArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TourCategoria_ToursArgs = {
  filters?: InputMaybe<CategoriaTourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TourCiudadesArgs = {
  filters?: InputMaybe<CiudadeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TourEntity = {
  __typename?: 'TourEntity';
  attributes?: Maybe<Tour>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TourEntityResponse = {
  __typename?: 'TourEntityResponse';
  data?: Maybe<TourEntity>;
};

export type TourEntityResponseCollection = {
  __typename?: 'TourEntityResponseCollection';
  data: Array<TourEntity>;
  meta: ResponseCollectionMeta;
};

export type TourFiltersInput = {
  Descripcion?: InputMaybe<StringFilterInput>;
  DescripcionCorta?: InputMaybe<StringFilterInput>;
  Nombre?: InputMaybe<StringFilterInput>;
  VisibilidadClienteFinal?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TourFiltersInput>>>;
  antesdeAsistir?: InputMaybe<StringFilterInput>;
  cantidadStock?: InputMaybe<LongFilterInput>;
  categoria_tours?: InputMaybe<CategoriaTourFiltersInput>;
  ciudad?: InputMaybe<StringFilterInput>;
  ciudades?: InputMaybe<CiudadeFiltersInput>;
  contieneStock?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  descuento?: InputMaybe<IntFilterInput>;
  etiquetas?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  informacionGeneral?: InputMaybe<JsonFilterInput>;
  medidasHigiene?: InputMaybe<JsonFilterInput>;
  nombreFacturarAgencia?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TourFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TourFiltersInput>>>;
  politicasdeCancelacion?: InputMaybe<StringFilterInput>;
  precio?: InputMaybe<LongFilterInput>;
  proveedor?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  variantes?: InputMaybe<JsonFilterInput>;
};

export type TourInput = {
  Descripcion?: InputMaybe<Scalars['String']['input']>;
  DescripcionCorta?: InputMaybe<Scalars['String']['input']>;
  Galeria?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ImagenDestacada?: InputMaybe<Scalars['ID']['input']>;
  Nombre?: InputMaybe<Scalars['String']['input']>;
  VisibilidadClienteFinal?: InputMaybe<Scalars['Boolean']['input']>;
  antesdeAsistir?: InputMaybe<Scalars['String']['input']>;
  cantidadStock?: InputMaybe<Scalars['Long']['input']>;
  categoria_tours?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ciudad?: InputMaybe<Scalars['String']['input']>;
  ciudades?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contieneStock?: InputMaybe<Scalars['Boolean']['input']>;
  descuento?: InputMaybe<Scalars['Int']['input']>;
  etiquetas?: InputMaybe<Scalars['String']['input']>;
  informacionGeneral?: InputMaybe<Scalars['JSON']['input']>;
  medidasHigiene?: InputMaybe<Scalars['JSON']['input']>;
  nombreFacturarAgencia?: InputMaybe<Scalars['String']['input']>;
  politicasdeCancelacion?: InputMaybe<Scalars['String']['input']>;
  precio?: InputMaybe<Scalars['Long']['input']>;
  proveedor?: InputMaybe<Scalars['String']['input']>;
  variantes?: InputMaybe<Scalars['JSON']['input']>;
};

export type TourRelationResponseCollection = {
  __typename?: 'TourRelationResponseCollection';
  data: Array<TourEntity>;
};

export type Traslado = {
  __typename?: 'Traslado';
  Direccion: Scalars['String']['output'];
  EnelHotel?: Maybe<Scalars['String']['output']>;
  EnelHotelin?: Maybe<Scalars['String']['output']>;
  EnelHotelpor?: Maybe<Scalars['String']['output']>;
  EnquePartedelaZonadeArribosEsperarasalPasajero: Scalars['String']['output'];
  EnquePartedelaZonadeArribosEsperarasalPasajeroin?: Maybe<Scalars['String']['output']>;
  EnquePartedelaZonadeArribosEsperarasalPasajeropor?: Maybe<Scalars['String']['output']>;
  QueseNecesitaParaRealizarelTraslado: Scalars['String']['output'];
  QueseNecesitaParaRealizarelTrasladoin?: Maybe<Scalars['String']['output']>;
  QueseNecesitaParaRealizarelTrasladopor?: Maybe<Scalars['String']['output']>;
  TipodeServicio: Scalars['String']['output'];
  aeropuerto?: Maybe<AeropuertoEntityResponse>;
  blackOutDesde?: Maybe<Scalars['Date']['output']>;
  blackOutHasta?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  destino: Scalars['String']['output'];
  dias?: Maybe<Scalars['JSON']['output']>;
  duracionMaximaHoras?: Maybe<Scalars['Int']['output']>;
  duracionMaximaMinutos?: Maybe<Scalars['Int']['output']>;
  emailContacto: Scalars['String']['output'];
  horarioDesde?: Maybe<Scalars['Time']['output']>;
  horarioHasta?: Maybe<Scalars['Time']['output']>;
  horasAnticipacion?: Maybe<Scalars['Int']['output']>;
  isAds?: Maybe<Scalars['Boolean']['output']>;
  isLike?: Maybe<Scalars['Boolean']['output']>;
  precio?: Maybe<Scalars['Long']['output']>;
  saleOff?: Maybe<Scalars['Boolean']['output']>;
  tarifaDesde?: Maybe<Scalars['String']['output']>;
  tarifaHasta?: Maybe<Scalars['String']['output']>;
  tel1: Scalars['String']['output'];
  tel2?: Maybe<Scalars['String']['output']>;
  tel3?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vehiculo?: Maybe<VehiculoEntityResponse>;
  zona?: Maybe<ZonaEntityResponse>;
  zonadeArribos: Scalars['String']['output'];
};

export type TrasladoEntity = {
  __typename?: 'TrasladoEntity';
  attributes?: Maybe<Traslado>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TrasladoEntityResponse = {
  __typename?: 'TrasladoEntityResponse';
  data?: Maybe<TrasladoEntity>;
};

export type TrasladoEntityResponseCollection = {
  __typename?: 'TrasladoEntityResponseCollection';
  data: Array<TrasladoEntity>;
  meta: ResponseCollectionMeta;
};

export type TrasladoFiltersInput = {
  Direccion?: InputMaybe<StringFilterInput>;
  EnelHotel?: InputMaybe<StringFilterInput>;
  EnelHotelin?: InputMaybe<StringFilterInput>;
  EnelHotelpor?: InputMaybe<StringFilterInput>;
  EnquePartedelaZonadeArribosEsperarasalPasajero?: InputMaybe<StringFilterInput>;
  EnquePartedelaZonadeArribosEsperarasalPasajeroin?: InputMaybe<StringFilterInput>;
  EnquePartedelaZonadeArribosEsperarasalPasajeropor?: InputMaybe<StringFilterInput>;
  QueseNecesitaParaRealizarelTraslado?: InputMaybe<StringFilterInput>;
  QueseNecesitaParaRealizarelTrasladoin?: InputMaybe<StringFilterInput>;
  QueseNecesitaParaRealizarelTrasladopor?: InputMaybe<StringFilterInput>;
  TipodeServicio?: InputMaybe<StringFilterInput>;
  aeropuerto?: InputMaybe<AeropuertoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<TrasladoFiltersInput>>>;
  blackOutDesde?: InputMaybe<DateFilterInput>;
  blackOutHasta?: InputMaybe<DateFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  destino?: InputMaybe<StringFilterInput>;
  dias?: InputMaybe<JsonFilterInput>;
  duracionMaximaHoras?: InputMaybe<IntFilterInput>;
  duracionMaximaMinutos?: InputMaybe<IntFilterInput>;
  emailContacto?: InputMaybe<StringFilterInput>;
  horarioDesde?: InputMaybe<TimeFilterInput>;
  horarioHasta?: InputMaybe<TimeFilterInput>;
  horasAnticipacion?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isAds?: InputMaybe<BooleanFilterInput>;
  isLike?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<TrasladoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TrasladoFiltersInput>>>;
  precio?: InputMaybe<LongFilterInput>;
  saleOff?: InputMaybe<BooleanFilterInput>;
  tarifaDesde?: InputMaybe<StringFilterInput>;
  tarifaHasta?: InputMaybe<StringFilterInput>;
  tel1?: InputMaybe<StringFilterInput>;
  tel2?: InputMaybe<StringFilterInput>;
  tel3?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  vehiculo?: InputMaybe<VehiculoFiltersInput>;
  zona?: InputMaybe<ZonaFiltersInput>;
  zonadeArribos?: InputMaybe<StringFilterInput>;
};

export type TrasladoInput = {
  Direccion?: InputMaybe<Scalars['String']['input']>;
  EnelHotel?: InputMaybe<Scalars['String']['input']>;
  EnelHotelin?: InputMaybe<Scalars['String']['input']>;
  EnelHotelpor?: InputMaybe<Scalars['String']['input']>;
  EnquePartedelaZonadeArribosEsperarasalPasajero?: InputMaybe<Scalars['String']['input']>;
  EnquePartedelaZonadeArribosEsperarasalPasajeroin?: InputMaybe<Scalars['String']['input']>;
  EnquePartedelaZonadeArribosEsperarasalPasajeropor?: InputMaybe<Scalars['String']['input']>;
  QueseNecesitaParaRealizarelTraslado?: InputMaybe<Scalars['String']['input']>;
  QueseNecesitaParaRealizarelTrasladoin?: InputMaybe<Scalars['String']['input']>;
  QueseNecesitaParaRealizarelTrasladopor?: InputMaybe<Scalars['String']['input']>;
  TipodeServicio?: InputMaybe<Scalars['String']['input']>;
  aeropuerto?: InputMaybe<Scalars['ID']['input']>;
  blackOutDesde?: InputMaybe<Scalars['Date']['input']>;
  blackOutHasta?: InputMaybe<Scalars['Date']['input']>;
  destino?: InputMaybe<Scalars['String']['input']>;
  dias?: InputMaybe<Scalars['JSON']['input']>;
  duracionMaximaHoras?: InputMaybe<Scalars['Int']['input']>;
  duracionMaximaMinutos?: InputMaybe<Scalars['Int']['input']>;
  emailContacto?: InputMaybe<Scalars['String']['input']>;
  horarioDesde?: InputMaybe<Scalars['Time']['input']>;
  horarioHasta?: InputMaybe<Scalars['Time']['input']>;
  horasAnticipacion?: InputMaybe<Scalars['Int']['input']>;
  isAds?: InputMaybe<Scalars['Boolean']['input']>;
  isLike?: InputMaybe<Scalars['Boolean']['input']>;
  precio?: InputMaybe<Scalars['Long']['input']>;
  saleOff?: InputMaybe<Scalars['Boolean']['input']>;
  tarifaDesde?: InputMaybe<Scalars['String']['input']>;
  tarifaHasta?: InputMaybe<Scalars['String']['input']>;
  tel1?: InputMaybe<Scalars['String']['input']>;
  tel2?: InputMaybe<Scalars['String']['input']>;
  tel3?: InputMaybe<Scalars['String']['input']>;
  vehiculo?: InputMaybe<Scalars['ID']['input']>;
  zona?: InputMaybe<Scalars['ID']['input']>;
  zonadeArribos?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  Whatsapp: Scalars['String']['input'];
  cedula: Scalars['String']['input'];
  email: Scalars['String']['input'];
  nameComplete: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  Estado?: Maybe<Scalars['String']['output']>;
  Whatsapp: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  cedula?: Maybe<Scalars['Long']['output']>;
  cedularesponsableplataforma?: Maybe<Scalars['String']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  nameComplete?: Maybe<Scalars['String']['output']>;
  namerepresentante?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  razonsocial?: Maybe<Scalars['String']['output']>;
  responsableplataforma?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  Estado?: InputMaybe<StringFilterInput>;
  Whatsapp?: InputMaybe<StringFilterInput>;
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  cedula?: InputMaybe<LongFilterInput>;
  cedularesponsableplataforma?: InputMaybe<StringFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  nameComplete?: InputMaybe<StringFilterInput>;
  namerepresentante?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  razonsocial?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  responsableplataforma?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  Estado?: InputMaybe<Scalars['String']['input']>;
  Whatsapp?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  cedula?: InputMaybe<Scalars['Long']['input']>;
  cedularesponsableplataforma?: InputMaybe<Scalars['String']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  nameComplete?: InputMaybe<Scalars['String']['input']>;
  namerepresentante?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  razonsocial?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  responsableplataforma?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type Vehiculo = {
  __typename?: 'Vehiculo';
  CapacidadMaximaPasajeros: Scalars['Int']['output'];
  Categoria: Scalars['String']['output'];
  bolsodeManoporPersona: Scalars['Int']['output'];
  capacidadMaximadeParadas?: Maybe<Scalars['Int']['output']>;
  capacidadMinimaPasajeros: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  imagenReferencia?: Maybe<UploadFileEntityResponse>;
  tipodeServicio: Scalars['String']['output'];
  tipodeVehiculo: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  valijasPorPersona: Scalars['Int']['output'];
};

export type VehiculoEntity = {
  __typename?: 'VehiculoEntity';
  attributes?: Maybe<Vehiculo>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type VehiculoEntityResponse = {
  __typename?: 'VehiculoEntityResponse';
  data?: Maybe<VehiculoEntity>;
};

export type VehiculoEntityResponseCollection = {
  __typename?: 'VehiculoEntityResponseCollection';
  data: Array<VehiculoEntity>;
  meta: ResponseCollectionMeta;
};

export type VehiculoFiltersInput = {
  CapacidadMaximaPasajeros?: InputMaybe<IntFilterInput>;
  Categoria?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<VehiculoFiltersInput>>>;
  bolsodeManoporPersona?: InputMaybe<IntFilterInput>;
  capacidadMaximadeParadas?: InputMaybe<IntFilterInput>;
  capacidadMinimaPasajeros?: InputMaybe<IntFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<VehiculoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<VehiculoFiltersInput>>>;
  tipodeServicio?: InputMaybe<StringFilterInput>;
  tipodeVehiculo?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  valijasPorPersona?: InputMaybe<IntFilterInput>;
};

export type VehiculoInput = {
  CapacidadMaximaPasajeros?: InputMaybe<Scalars['Int']['input']>;
  Categoria?: InputMaybe<Scalars['String']['input']>;
  bolsodeManoporPersona?: InputMaybe<Scalars['Int']['input']>;
  capacidadMaximadeParadas?: InputMaybe<Scalars['Int']['input']>;
  capacidadMinimaPasajeros?: InputMaybe<Scalars['Int']['input']>;
  imagenReferencia?: InputMaybe<Scalars['ID']['input']>;
  tipodeServicio?: InputMaybe<Scalars['String']['input']>;
  tipodeVehiculo?: InputMaybe<Scalars['String']['input']>;
  valijasPorPersona?: InputMaybe<Scalars['Int']['input']>;
};

export type Zona = {
  __typename?: 'Zona';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  destino: Scalars['String']['output'];
  nombre: Scalars['String']['output'];
  precioAeropuertoZona?: Maybe<Scalars['Long']['output']>;
  precioZonaAeropuerto: Scalars['Long']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zonaMap: Scalars['JSON']['output'];
};

export type ZonaEntity = {
  __typename?: 'ZonaEntity';
  attributes?: Maybe<Zona>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ZonaEntityResponse = {
  __typename?: 'ZonaEntityResponse';
  data?: Maybe<ZonaEntity>;
};

export type ZonaEntityResponseCollection = {
  __typename?: 'ZonaEntityResponseCollection';
  data: Array<ZonaEntity>;
  meta: ResponseCollectionMeta;
};

export type ZonaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ZonaFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  destino?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  nombre?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ZonaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ZonaFiltersInput>>>;
  precioAeropuertoZona?: InputMaybe<LongFilterInput>;
  precioZonaAeropuerto?: InputMaybe<LongFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  zonaMap?: InputMaybe<JsonFilterInput>;
};

export type ZonaInput = {
  destino?: InputMaybe<Scalars['String']['input']>;
  nombre?: InputMaybe<Scalars['String']['input']>;
  precioAeropuertoZona?: InputMaybe<Scalars['Long']['input']>;
  precioZonaAeropuerto?: InputMaybe<Scalars['Long']['input']>;
  zonaMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null } } | null };

export type LoginMutationVariables = Exact<{
  input: UsersPermissionsLoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } } };

export type RegisterMutationVariables = Exact<{
  input: UsersPermissionsRegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } } };

export type UpdateUsersPermissionsUserMutationVariables = Exact<{
  updateUsersPermissionsUserId: Scalars['ID']['input'];
  data: UsersPermissionsUserInput;
}>;


export type UpdateUsersPermissionsUserMutation = { __typename?: 'Mutation', updateUsersPermissionsUser: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', attributes?: { __typename?: 'UsersPermissionsUser', cedula?: any | null, Whatsapp: string, email: string, nameComplete?: string | null, username: string } | null } | null } };

export type CreateCompraMutationVariables = Exact<{
  data: CompraInput;
}>;


export type CreateCompraMutation = { __typename?: 'Mutation', createCompra?: { __typename?: 'CompraEntityResponse', data?: { __typename?: 'CompraEntity', attributes?: { __typename?: 'Compra', fechaDeCompra?: string | null, total?: any | null, estado?: boolean | null, cantidadDePersonas?: number | null, fechadelServicio?: string | null, idMoneda?: string | null, idCompraMercadoPago?: string | null, orderMercadoPago?: any | null, payerMercadoPago?: any | null, paymentMethodMercadoPago?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type AeropuertosQueryVariables = Exact<{
  filters?: InputMaybe<AeropuertoFiltersInput>;
}>;


export type AeropuertosQuery = { __typename?: 'Query', aeropuertos?: { __typename?: 'AeropuertoEntityResponseCollection', data: Array<{ __typename?: 'AeropuertoEntity', id?: string | null, attributes?: { __typename?: 'Aeropuerto', aeropuerto: string } | null }> } | null };

export type CmsQueryVariables = Exact<{ [key: string]: never; }>;


export type CmsQuery = { __typename?: 'Query', cms?: { __typename?: 'CmsEntityResponse', data?: { __typename?: 'CmsEntity', id?: string | null, attributes?: { __typename?: 'Cms', tituloHeader?: string | null, subTituloHeader?: string | null, textoBotonHeader?: string | null, tituloCiudades?: string | null, subTituloCiudades?: string | null, sloganBeneficios?: string | null, tituloBeneficios?: string | null, tag1Beneficios?: string | null, tag2Beneficios?: string | null, tag3Beneficios?: string | null, itemTitulo1Beneficios?: string | null, itemTitulo2Beneficios?: string | null, itemTitulo3Beneficios?: string | null, itemDescripcion1Beneficios?: string | null, itemDescripcion2Beneficios?: string | null, itemDescripcion3Beneficios?: string | null, tituloTours?: string | null, descripcionTours?: string | null, tituloComoFunciona?: string | null, descripcionComoFunciona?: string | null, item1TituloComoFunciona?: string | null, item2TituloComoFunciona?: string | null, item3TituloComoFunciona?: string | null, item1DescripcionComoFunciona?: string | null, item2DescripcionComoFunciona?: string | null, item3DescripcionComoFunciona?: string | null, tituloBoletin?: string | null, descripcionBoletin?: string | null, item1Boletin?: string | null, item2Boletin?: string | null, tituloVideo?: string | null, DescripcionVideo?: string | null, tituloTestimonios?: string | null, descripcionTestimonios?: string | null, createdAt?: any | null, updatedAt?: any | null, img1Header?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, img2Header?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, img3Header?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, videos?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, logoClaro?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, logoOscuro?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null };

export type CiudadesQueryVariables = Exact<{ [key: string]: never; }>;


export type CiudadesQuery = { __typename?: 'Query', ciudades?: { __typename?: 'CiudadeEntityResponseCollection', data: Array<{ __typename?: 'CiudadeEntity', attributes?: { __typename?: 'Ciudade', nombre?: string | null, imagen?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null }> } | null };

export type CiudadesFiltersQueryVariables = Exact<{
  filters?: InputMaybe<CiudadeFiltersInput>;
}>;


export type CiudadesFiltersQuery = { __typename?: 'Query', ciudades?: { __typename?: 'CiudadeEntityResponseCollection', data: Array<{ __typename?: 'CiudadeEntity', id?: string | null, attributes?: { __typename?: 'Ciudade', nombre?: string | null } | null }> } | null };

export type ComprasQueryVariables = Exact<{
  filters?: InputMaybe<CompraFiltersInput>;
}>;


export type ComprasQuery = { __typename?: 'Query', compras?: { __typename?: 'CompraEntityResponseCollection', data: Array<{ __typename?: 'CompraEntity', attributes?: { __typename?: 'Compra', total?: any | null, cantidadDePersonas?: number | null, idMoneda?: string | null, tour?: { __typename?: 'TourEntityResponse', data?: { __typename?: 'TourEntity', id?: string | null, attributes?: { __typename?: 'Tour', Nombre: string, ciudad?: string | null, precio: any, ImagenDestacada: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null }, categoria_tours?: { __typename?: 'CategoriaTourRelationResponseCollection', data: Array<{ __typename?: 'CategoriaTourEntity', attributes?: { __typename?: 'CategoriaTour', nombre: string } | null }> } | null, Galeria?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null } | null } | null } | null, traslado?: { __typename?: 'TrasladoEntityResponse', data?: { __typename?: 'TrasladoEntity', id?: string | null, attributes?: { __typename?: 'Traslado', zonadeArribos: string, precio?: any | null, TipodeServicio: string, destino: string, vehiculo?: { __typename?: 'VehiculoEntityResponse', data?: { __typename?: 'VehiculoEntity', attributes?: { __typename?: 'Vehiculo', tipodeVehiculo: string, imagenReferencia?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null }> } | null };

export type TourQueryVariables = Exact<{
  tourId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TourQuery = { __typename?: 'Query', tour?: { __typename?: 'TourEntityResponse', data?: { __typename?: 'TourEntity', id?: string | null, attributes?: { __typename?: 'Tour', Descripcion: string, DescripcionCorta?: string | null, Nombre: string, precio: any, ciudad?: string | null, descuento?: number | null, etiquetas?: string | null, proveedor?: string | null, variantes?: any | null, contieneStock?: boolean | null, cantidadStock?: any | null, antesdeAsistir?: string | null, VisibilidadClienteFinal?: boolean | null, informacionGeneral?: any | null, medidasHigiene?: any | null, nombreFacturarAgencia?: string | null, politicasdeCancelacion?: string | null, Galeria?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, ImagenDestacada: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null }, categoria_tours?: { __typename?: 'CategoriaTourRelationResponseCollection', data: Array<{ __typename?: 'CategoriaTourEntity', attributes?: { __typename?: 'CategoriaTour', nombre: string } | null }> } | null } | null } | null } | null };

export type ToursQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArg>;
  filters?: InputMaybe<TourFiltersInput>;
}>;


export type ToursQuery = { __typename?: 'Query', tours?: { __typename?: 'TourEntityResponseCollection', data: Array<{ __typename?: 'TourEntity', id?: string | null, attributes?: { __typename?: 'Tour', DescripcionCorta?: string | null, Descripcion: string, Nombre: string, ciudad?: string | null, descuento?: number | null, precio: any, variantes?: any | null, contieneStock?: boolean | null, cantidadStock?: any | null, ImagenDestacada: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null }, Galeria?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, categoria_tours?: { __typename?: 'CategoriaTourRelationResponseCollection', data: Array<{ __typename?: 'CategoriaTourEntity', attributes?: { __typename?: 'CategoriaTour', nombre: string } | null }> } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } } | null };

export type TrasladoQueryVariables = Exact<{
  trasladoId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TrasladoQuery = { __typename?: 'Query', traslado?: { __typename?: 'TrasladoEntityResponse', data?: { __typename?: 'TrasladoEntity', id?: string | null, attributes?: { __typename?: 'Traslado', destino: string, TipodeServicio: string, EnquePartedelaZonadeArribosEsperarasalPasajero: string, EnelHotel?: string | null, emailContacto: string, Direccion: string, tel1: string, tel2?: string | null, tel3?: string | null, QueseNecesitaParaRealizarelTraslado: string, EnquePartedelaZonadeArribosEsperarasalPasajeroin?: string | null, EnquePartedelaZonadeArribosEsperarasalPasajeropor?: string | null, QueseNecesitaParaRealizarelTrasladoin?: string | null, QueseNecesitaParaRealizarelTrasladopor?: string | null, EnelHotelin?: string | null, EnelHotelpor?: string | null, dias?: any | null, horarioDesde?: any | null, horarioHasta?: any | null, horasAnticipacion?: number | null, duracionMaximaHoras?: number | null, duracionMaximaMinutos?: number | null, precio?: any | null, tarifaDesde?: string | null, tarifaHasta?: string | null, isAds?: boolean | null, isLike?: boolean | null, saleOff?: boolean | null, createdAt?: any | null, updatedAt?: any | null, zonadeArribos: string, aeropuerto?: { __typename?: 'AeropuertoEntityResponse', data?: { __typename?: 'AeropuertoEntity', attributes?: { __typename?: 'Aeropuerto', aeropuerto: string } | null } | null } | null, vehiculo?: { __typename?: 'VehiculoEntityResponse', data?: { __typename?: 'VehiculoEntity', attributes?: { __typename?: 'Vehiculo', tipodeVehiculo: string, imagenReferencia?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type TrasladosQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArg>;
  filters?: InputMaybe<TrasladoFiltersInput>;
}>;


export type TrasladosQuery = { __typename?: 'Query', traslados?: { __typename?: 'TrasladoEntityResponseCollection', data: Array<{ __typename?: 'TrasladoEntity', id?: string | null, attributes?: { __typename?: 'Traslado', Direccion: string, precio?: any | null, zonadeArribos: string, destino: string, TipodeServicio: string, isAds?: boolean | null, isLike?: boolean | null, duracionMaximaHoras?: number | null, duracionMaximaMinutos?: number | null, vehiculo?: { __typename?: 'VehiculoEntityResponse', data?: { __typename?: 'VehiculoEntity', attributes?: { __typename?: 'Vehiculo', CapacidadMaximaPasajeros: number, tipodeVehiculo: string, imagenReferencia?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null, aeropuerto?: { __typename?: 'AeropuertoEntityResponse', data?: { __typename?: 'AeropuertoEntity', attributes?: { __typename?: 'Aeropuerto', aeropuerto: string, toleranciaDeEspera: string } | null } | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } } | null };

export type UsersPermissionsUserQueryVariables = Exact<{
  usersPermissionsUserId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UsersPermissionsUserQuery = { __typename?: 'Query', usersPermissionsUser?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', attributes?: { __typename?: 'UsersPermissionsUser', Whatsapp: string, cedula?: any | null, email: string, nameComplete?: string | null, username: string, address?: string | null } | null } | null } | null };


export const ChangePasswordDocument = gql`
    mutation ChangePassword($currentPassword: String!, $password: String!, $passwordConfirmation: String!) {
  changePassword(
    currentPassword: $currentPassword
    password: $password
    passwordConfirmation: $passwordConfirmation
  ) {
    jwt
    user {
      id
      username
      email
      confirmed
      blocked
    }
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const LoginDocument = gql`
    mutation Login($input: UsersPermissionsLoginInput!) {
  login(input: $input) {
    jwt
    user {
      id
      username
      email
      confirmed
      blocked
      role {
        id
        name
        description
        type
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($input: UsersPermissionsRegisterInput!) {
  register(input: $input) {
    jwt
    user {
      id
      username
      email
      confirmed
      blocked
      role {
        id
        name
        description
        type
      }
    }
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const UpdateUsersPermissionsUserDocument = gql`
    mutation UpdateUsersPermissionsUser($updateUsersPermissionsUserId: ID!, $data: UsersPermissionsUserInput!) {
  updateUsersPermissionsUser(id: $updateUsersPermissionsUserId, data: $data) {
    data {
      attributes {
        cedula
        Whatsapp
        email
        nameComplete
        username
      }
    }
  }
}
    `;
export type UpdateUsersPermissionsUserMutationFn = Apollo.MutationFunction<UpdateUsersPermissionsUserMutation, UpdateUsersPermissionsUserMutationVariables>;

/**
 * __useUpdateUsersPermissionsUserMutation__
 *
 * To run a mutation, you first call `useUpdateUsersPermissionsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersPermissionsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersPermissionsUserMutation, { data, loading, error }] = useUpdateUsersPermissionsUserMutation({
 *   variables: {
 *      updateUsersPermissionsUserId: // value for 'updateUsersPermissionsUserId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUsersPermissionsUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUsersPermissionsUserMutation, UpdateUsersPermissionsUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUsersPermissionsUserMutation, UpdateUsersPermissionsUserMutationVariables>(UpdateUsersPermissionsUserDocument, options);
      }
export type UpdateUsersPermissionsUserMutationHookResult = ReturnType<typeof useUpdateUsersPermissionsUserMutation>;
export type UpdateUsersPermissionsUserMutationResult = Apollo.MutationResult<UpdateUsersPermissionsUserMutation>;
export type UpdateUsersPermissionsUserMutationOptions = Apollo.BaseMutationOptions<UpdateUsersPermissionsUserMutation, UpdateUsersPermissionsUserMutationVariables>;
export const CreateCompraDocument = gql`
    mutation CreateCompra($data: CompraInput!) {
  createCompra(data: $data) {
    data {
      attributes {
        fechaDeCompra
        total
        estado
        cantidadDePersonas
        fechadelServicio
        idMoneda
        idCompraMercadoPago
        orderMercadoPago
        payerMercadoPago
        paymentMethodMercadoPago
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export type CreateCompraMutationFn = Apollo.MutationFunction<CreateCompraMutation, CreateCompraMutationVariables>;

/**
 * __useCreateCompraMutation__
 *
 * To run a mutation, you first call `useCreateCompraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompraMutation, { data, loading, error }] = useCreateCompraMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCompraMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompraMutation, CreateCompraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompraMutation, CreateCompraMutationVariables>(CreateCompraDocument, options);
      }
export type CreateCompraMutationHookResult = ReturnType<typeof useCreateCompraMutation>;
export type CreateCompraMutationResult = Apollo.MutationResult<CreateCompraMutation>;
export type CreateCompraMutationOptions = Apollo.BaseMutationOptions<CreateCompraMutation, CreateCompraMutationVariables>;
export const AeropuertosDocument = gql`
    query Aeropuertos($filters: AeropuertoFiltersInput) {
  aeropuertos(filters: $filters) {
    data {
      id
      attributes {
        aeropuerto
      }
    }
  }
}
    `;

/**
 * __useAeropuertosQuery__
 *
 * To run a query within a React component, call `useAeropuertosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAeropuertosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAeropuertosQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAeropuertosQuery(baseOptions?: Apollo.QueryHookOptions<AeropuertosQuery, AeropuertosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AeropuertosQuery, AeropuertosQueryVariables>(AeropuertosDocument, options);
      }
export function useAeropuertosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AeropuertosQuery, AeropuertosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AeropuertosQuery, AeropuertosQueryVariables>(AeropuertosDocument, options);
        }
export type AeropuertosQueryHookResult = ReturnType<typeof useAeropuertosQuery>;
export type AeropuertosLazyQueryHookResult = ReturnType<typeof useAeropuertosLazyQuery>;
export type AeropuertosQueryResult = Apollo.QueryResult<AeropuertosQuery, AeropuertosQueryVariables>;
export const CmsDocument = gql`
    query Cms {
  cms {
    data {
      id
      attributes {
        tituloHeader
        subTituloHeader
        textoBotonHeader
        img1Header {
          data {
            attributes {
              url
            }
          }
        }
        img2Header {
          data {
            attributes {
              url
            }
          }
        }
        img3Header {
          data {
            attributes {
              url
            }
          }
        }
        tituloCiudades
        subTituloCiudades
        sloganBeneficios
        tituloBeneficios
        tag1Beneficios
        tag2Beneficios
        tag3Beneficios
        itemTitulo1Beneficios
        itemTitulo2Beneficios
        itemTitulo3Beneficios
        itemDescripcion1Beneficios
        itemDescripcion2Beneficios
        itemDescripcion3Beneficios
        tituloTours
        descripcionTours
        tituloComoFunciona
        descripcionComoFunciona
        item1TituloComoFunciona
        item2TituloComoFunciona
        item3TituloComoFunciona
        item1DescripcionComoFunciona
        item2DescripcionComoFunciona
        item3DescripcionComoFunciona
        tituloBoletin
        descripcionBoletin
        item1Boletin
        item2Boletin
        tituloVideo
        DescripcionVideo
        videos {
          data {
            attributes {
              url
            }
          }
        }
        tituloTestimonios
        descripcionTestimonios
        logoClaro {
          data {
            attributes {
              url
            }
          }
        }
        logoOscuro {
          data {
            attributes {
              url
            }
          }
        }
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useCmsQuery__
 *
 * To run a query within a React component, call `useCmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCmsQuery(baseOptions?: Apollo.QueryHookOptions<CmsQuery, CmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsQuery, CmsQueryVariables>(CmsDocument, options);
      }
export function useCmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsQuery, CmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsQuery, CmsQueryVariables>(CmsDocument, options);
        }
export type CmsQueryHookResult = ReturnType<typeof useCmsQuery>;
export type CmsLazyQueryHookResult = ReturnType<typeof useCmsLazyQuery>;
export type CmsQueryResult = Apollo.QueryResult<CmsQuery, CmsQueryVariables>;
export const CiudadesDocument = gql`
    query Ciudades {
  ciudades {
    data {
      attributes {
        imagen {
          data {
            attributes {
              url
            }
          }
        }
        nombre
      }
    }
  }
}
    `;

/**
 * __useCiudadesQuery__
 *
 * To run a query within a React component, call `useCiudadesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCiudadesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCiudadesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCiudadesQuery(baseOptions?: Apollo.QueryHookOptions<CiudadesQuery, CiudadesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CiudadesQuery, CiudadesQueryVariables>(CiudadesDocument, options);
      }
export function useCiudadesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CiudadesQuery, CiudadesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CiudadesQuery, CiudadesQueryVariables>(CiudadesDocument, options);
        }
export type CiudadesQueryHookResult = ReturnType<typeof useCiudadesQuery>;
export type CiudadesLazyQueryHookResult = ReturnType<typeof useCiudadesLazyQuery>;
export type CiudadesQueryResult = Apollo.QueryResult<CiudadesQuery, CiudadesQueryVariables>;
export const CiudadesFiltersDocument = gql`
    query CiudadesFilters($filters: CiudadeFiltersInput) {
  ciudades(filters: $filters) {
    data {
      attributes {
        nombre
      }
      id
    }
  }
}
    `;

/**
 * __useCiudadesFiltersQuery__
 *
 * To run a query within a React component, call `useCiudadesFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCiudadesFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCiudadesFiltersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCiudadesFiltersQuery(baseOptions?: Apollo.QueryHookOptions<CiudadesFiltersQuery, CiudadesFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CiudadesFiltersQuery, CiudadesFiltersQueryVariables>(CiudadesFiltersDocument, options);
      }
export function useCiudadesFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CiudadesFiltersQuery, CiudadesFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CiudadesFiltersQuery, CiudadesFiltersQueryVariables>(CiudadesFiltersDocument, options);
        }
export type CiudadesFiltersQueryHookResult = ReturnType<typeof useCiudadesFiltersQuery>;
export type CiudadesFiltersLazyQueryHookResult = ReturnType<typeof useCiudadesFiltersLazyQuery>;
export type CiudadesFiltersQueryResult = Apollo.QueryResult<CiudadesFiltersQuery, CiudadesFiltersQueryVariables>;
export const ComprasDocument = gql`
    query Compras($filters: CompraFiltersInput) {
  compras(filters: $filters) {
    data {
      attributes {
        total
        cantidadDePersonas
        idMoneda
        tour {
          data {
            attributes {
              ImagenDestacada {
                data {
                  attributes {
                    url
                  }
                }
              }
              Nombre
              ciudad
              categoria_tours {
                data {
                  attributes {
                    nombre
                  }
                }
              }
              Galeria {
                data {
                  attributes {
                    url
                  }
                }
              }
              precio
            }
            id
          }
        }
        traslado {
          data {
            attributes {
              zonadeArribos
              vehiculo {
                data {
                  attributes {
                    tipodeVehiculo
                    imagenReferencia {
                      data {
                        attributes {
                          url
                        }
                      }
                    }
                  }
                }
              }
              precio
              TipodeServicio
              destino
            }
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useComprasQuery__
 *
 * To run a query within a React component, call `useComprasQuery` and pass it any options that fit your needs.
 * When your component renders, `useComprasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComprasQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useComprasQuery(baseOptions?: Apollo.QueryHookOptions<ComprasQuery, ComprasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComprasQuery, ComprasQueryVariables>(ComprasDocument, options);
      }
export function useComprasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComprasQuery, ComprasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComprasQuery, ComprasQueryVariables>(ComprasDocument, options);
        }
export type ComprasQueryHookResult = ReturnType<typeof useComprasQuery>;
export type ComprasLazyQueryHookResult = ReturnType<typeof useComprasLazyQuery>;
export type ComprasQueryResult = Apollo.QueryResult<ComprasQuery, ComprasQueryVariables>;
export const TourDocument = gql`
    query Tour($tourId: ID) {
  tour(id: $tourId) {
    data {
      attributes {
        Descripcion
        DescripcionCorta
        Galeria {
          data {
            attributes {
              url
            }
            id
          }
        }
        ImagenDestacada {
          data {
            attributes {
              url
            }
          }
        }
        Nombre
        categoria_tours {
          data {
            attributes {
              nombre
            }
          }
        }
        precio
        ciudad
        descuento
        etiquetas
        proveedor
        variantes
        contieneStock
        cantidadStock
        antesdeAsistir
        VisibilidadClienteFinal
        informacionGeneral
        medidasHigiene
        nombreFacturarAgencia
        politicasdeCancelacion
      }
      id
    }
  }
}
    `;

/**
 * __useTourQuery__
 *
 * To run a query within a React component, call `useTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourQuery({
 *   variables: {
 *      tourId: // value for 'tourId'
 *   },
 * });
 */
export function useTourQuery(baseOptions?: Apollo.QueryHookOptions<TourQuery, TourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TourQuery, TourQueryVariables>(TourDocument, options);
      }
export function useTourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TourQuery, TourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TourQuery, TourQueryVariables>(TourDocument, options);
        }
export type TourQueryHookResult = ReturnType<typeof useTourQuery>;
export type TourLazyQueryHookResult = ReturnType<typeof useTourLazyQuery>;
export type TourQueryResult = Apollo.QueryResult<TourQuery, TourQueryVariables>;
export const ToursDocument = gql`
    query Tours($pagination: PaginationArg, $filters: TourFiltersInput) {
  tours(pagination: $pagination, filters: $filters) {
    data {
      id
      attributes {
        DescripcionCorta
        Descripcion
        ImagenDestacada {
          data {
            attributes {
              url
            }
          }
        }
        Galeria {
          data {
            attributes {
              url
            }
          }
        }
        Nombre
        categoria_tours {
          data {
            attributes {
              nombre
            }
          }
        }
        ciudad
        descuento
        precio
        variantes
        contieneStock
        cantidadStock
      }
    }
    meta {
      pagination {
        total
      }
    }
  }
}
    `;

/**
 * __useToursQuery__
 *
 * To run a query within a React component, call `useToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToursQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useToursQuery(baseOptions?: Apollo.QueryHookOptions<ToursQuery, ToursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ToursQuery, ToursQueryVariables>(ToursDocument, options);
      }
export function useToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ToursQuery, ToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ToursQuery, ToursQueryVariables>(ToursDocument, options);
        }
export type ToursQueryHookResult = ReturnType<typeof useToursQuery>;
export type ToursLazyQueryHookResult = ReturnType<typeof useToursLazyQuery>;
export type ToursQueryResult = Apollo.QueryResult<ToursQuery, ToursQueryVariables>;
export const TrasladoDocument = gql`
    query Traslado($trasladoId: ID) {
  traslado(id: $trasladoId) {
    data {
      id
      attributes {
        aeropuerto {
          data {
            attributes {
              aeropuerto
            }
          }
        }
        destino
        TipodeServicio
        EnquePartedelaZonadeArribosEsperarasalPasajero
        EnelHotel
        emailContacto
        Direccion
        tel1
        tel2
        tel3
        QueseNecesitaParaRealizarelTraslado
        EnquePartedelaZonadeArribosEsperarasalPasajeroin
        EnquePartedelaZonadeArribosEsperarasalPasajeropor
        QueseNecesitaParaRealizarelTrasladoin
        QueseNecesitaParaRealizarelTrasladopor
        EnelHotelin
        EnelHotelpor
        dias
        horarioDesde
        horarioHasta
        horasAnticipacion
        duracionMaximaHoras
        duracionMaximaMinutos
        vehiculo {
          data {
            attributes {
              imagenReferencia {
                data {
                  attributes {
                    url
                  }
                }
              }
              tipodeVehiculo
            }
          }
        }
        precio
        tarifaDesde
        tarifaHasta
        isAds
        isLike
        saleOff
        createdAt
        updatedAt
        zonadeArribos
      }
    }
  }
}
    `;

/**
 * __useTrasladoQuery__
 *
 * To run a query within a React component, call `useTrasladoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrasladoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrasladoQuery({
 *   variables: {
 *      trasladoId: // value for 'trasladoId'
 *   },
 * });
 */
export function useTrasladoQuery(baseOptions?: Apollo.QueryHookOptions<TrasladoQuery, TrasladoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrasladoQuery, TrasladoQueryVariables>(TrasladoDocument, options);
      }
export function useTrasladoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrasladoQuery, TrasladoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrasladoQuery, TrasladoQueryVariables>(TrasladoDocument, options);
        }
export type TrasladoQueryHookResult = ReturnType<typeof useTrasladoQuery>;
export type TrasladoLazyQueryHookResult = ReturnType<typeof useTrasladoLazyQuery>;
export type TrasladoQueryResult = Apollo.QueryResult<TrasladoQuery, TrasladoQueryVariables>;
export const TrasladosDocument = gql`
    query Traslados($pagination: PaginationArg, $filters: TrasladoFiltersInput) {
  traslados(pagination: $pagination, filters: $filters) {
    data {
      id
      attributes {
        Direccion
        precio
        zonadeArribos
        vehiculo {
          data {
            attributes {
              imagenReferencia {
                data {
                  attributes {
                    url
                  }
                }
              }
              CapacidadMaximaPasajeros
              tipodeVehiculo
            }
          }
        }
        destino
        aeropuerto {
          data {
            attributes {
              aeropuerto
              toleranciaDeEspera
            }
          }
        }
        TipodeServicio
        isAds
        isLike
        duracionMaximaHoras
        duracionMaximaMinutos
      }
    }
    meta {
      pagination {
        total
      }
    }
  }
}
    `;

/**
 * __useTrasladosQuery__
 *
 * To run a query within a React component, call `useTrasladosQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrasladosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrasladosQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTrasladosQuery(baseOptions?: Apollo.QueryHookOptions<TrasladosQuery, TrasladosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrasladosQuery, TrasladosQueryVariables>(TrasladosDocument, options);
      }
export function useTrasladosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrasladosQuery, TrasladosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrasladosQuery, TrasladosQueryVariables>(TrasladosDocument, options);
        }
export type TrasladosQueryHookResult = ReturnType<typeof useTrasladosQuery>;
export type TrasladosLazyQueryHookResult = ReturnType<typeof useTrasladosLazyQuery>;
export type TrasladosQueryResult = Apollo.QueryResult<TrasladosQuery, TrasladosQueryVariables>;
export const UsersPermissionsUserDocument = gql`
    query UsersPermissionsUser($usersPermissionsUserId: ID) {
  usersPermissionsUser(id: $usersPermissionsUserId) {
    data {
      attributes {
        Whatsapp
        cedula
        email
        nameComplete
        username
        address
      }
    }
  }
}
    `;

/**
 * __useUsersPermissionsUserQuery__
 *
 * To run a query within a React component, call `useUsersPermissionsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPermissionsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPermissionsUserQuery({
 *   variables: {
 *      usersPermissionsUserId: // value for 'usersPermissionsUserId'
 *   },
 * });
 */
export function useUsersPermissionsUserQuery(baseOptions?: Apollo.QueryHookOptions<UsersPermissionsUserQuery, UsersPermissionsUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersPermissionsUserQuery, UsersPermissionsUserQueryVariables>(UsersPermissionsUserDocument, options);
      }
export function useUsersPermissionsUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersPermissionsUserQuery, UsersPermissionsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersPermissionsUserQuery, UsersPermissionsUserQueryVariables>(UsersPermissionsUserDocument, options);
        }
export type UsersPermissionsUserQueryHookResult = ReturnType<typeof useUsersPermissionsUserQuery>;
export type UsersPermissionsUserLazyQueryHookResult = ReturnType<typeof useUsersPermissionsUserLazyQuery>;
export type UsersPermissionsUserQueryResult = Apollo.QueryResult<UsersPermissionsUserQuery, UsersPermissionsUserQueryVariables>;